/**
 * Detects when resolving a conversation is blocked by the linked Kanban stage.
 * @param {object|null|undefined} conversation
 * @returns {{ blocked: boolean, stepName: string|null }}
 */
export const getKanbanResolveBlock = conversation => {
  const task = conversation?.kanban_task;
  if (!task?.board_step_id) {
    return { blocked: false, stepName: null };
  }

  const steps = task.board?.steps || [];
  const fromSteps = steps.find(
    step => String(step.id) === String(task.board_step_id)
  );
  const fromTaskStep =
    task.board_step && String(task.board_step.id) === String(task.board_step_id)
      ? task.board_step
      : null;

  // Prefer board_step from the latest task payload (e.g. after a move/cable update)
  // over a preserved board.steps list that may still carry a stale lock flag.
  const currentStep = fromTaskStep
    ? { ...fromSteps, ...fromTaskStep }
    : fromSteps || task.board_step;

  if (!currentStep?.block_conversation_resolve) {
    return { blocked: false, stepName: null };
  }

  return {
    blocked: true,
    stepName: currentStep.name || null,
  };
};

export default getKanbanResolveBlock;
